<div class="px-4 pt-4 relative">
    <div class="flex items-center justify-between gap-2">
        <h2 class="m-0 text-xl font-medium leading-tight text-slate-900">Appointment Details</h2>

        <div class="flex items-center gap-2">
            <span [ngClass]="{
                    'bg-emerald-50 text-emerald-700': appointmentStatus === 'Confirmed',
                    'bg-amber-50 text-amber-700': appointmentStatus === 'Pending',
                    'bg-red-50 text-red-700': appointmentStatus === 'Cancelled',
                    'bg-slate-100 text-slate-600': appointmentStatus === 'Completed'
                }" class="inline-flex items-center rounded-full px-2.5 py-1 text-xs font-semibold whitespace-nowrap">
                {{ appointmentStatus }}
            </span>

            <button type="button"
                class="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg border-0 bg-transparent text-slate-400 outline-none transition hover:bg-slate-100 hover:text-slate-600 focus:outline-none"
                (click)="close()">
                <i class="las la-times text-xl leading-none"></i>
            </button>
        </div>
    </div>

    <div class="mt-1.5 flex flex-wrap items-center gap-2 text-sm font-normal text-slate-400">
        <span>{{ appointmentDay }}</span>
        <span class="h-1 w-1 rounded-full bg-slate-300"></span>
        <span>{{ appointmentDate }}</span>
    </div>
    <div class="mt-3 h-px w-full bg-slate-100"></div>
</div>

<div class="px-4 pb-4 pt-4">
    <div class="space-y-3">
        <div class="flex gap-3">
            <div
                class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-teal-50 text-2xl text-teal-700">
                <i class="las la-user leading-none"></i>
            </div>
            <div class="min-w-0">
                <p class="m-0 text-sm font-normal text-slate-400">Patient</p>
                <h3 class="m-0 mt-1 truncate text-base font-semibold text-slate-900">{{ patientName }}</h3>
                <p class="m-0 mt-0.5 text-xs font-medium text-slate-500">{{ patientId }}</p>
            </div>
        </div>

        <div class="flex gap-3 mt-3">
            <div
                class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-blue-50 text-2xl text-blue-700">
                <i class="las la-calendar-check leading-none"></i>
            </div>
            <div class="min-w-0">
                <p class="m-0 text-sm font-normal text-slate-400">Date and Time</p>
                <h3 class="m-0 mt-1 truncate text-base font-semibold text-slate-900">
                    {{ appointmentDate }} at {{ appointmentTime }}
                </h3>
            </div>
        </div>

        <div class="flex gap-3 mt-3">
            <div
                class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-violet-50 text-2xl text-violet-700">
                <i class="las la-stethoscope leading-none"></i>
            </div>
            <div class="min-w-0">
                <p class="m-0 text-sm font-normal text-slate-400">Doctor</p>
                <h3 class="m-0 mt-1 truncate text-base font-semibold text-slate-900">{{ doctorName }}</h3>
            </div>
        </div>

        <div class="flex gap-3 mt-3">
            <div
                class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-amber-50 text-2xl text-amber-700">
                <i class="las la-tooth leading-none"></i>
            </div>
            <div class="min-w-0">
                <p class="m-0 text-sm font-normal text-slate-400">Treatment</p>
                <h3 class="m-0 mt-1 truncate text-base font-semibold text-slate-900">{{ treatmentName }}</h3>
            </div>
        </div>

        <div class="flex gap-3 mt-3">
            <div
                class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-emerald-50 text-2xl text-emerald-700">
                <i class="las la-phone leading-none"></i>
            </div>
            <div class="min-w-0">
                <p class="m-0 text-sm font-normal text-slate-400">Phone Number</p>
                <h3 class="m-0 mt-1 text-base font-semibold text-slate-900">{{ phoneNumber }}</h3>
            </div>
        </div>
    </div>

    <div class="mt-6 rounded-xl border border-slate-100 bg-slate-50 p-3">
        <p class="m-0 text-sm font-normal text-slate-400">Notes</p>
        <p class="m-0 mt-1 text-base leading-5 text-slate-900">{{ notes }}</p>
    </div>
    <div class="mt-4 flex flex-col-reverse gap-3 sm:flex-row sm:justify-between">
        <button *ngIf="showRescheduleButton" type="button"
            class="inline-flex h-11 flex-1 items-center justify-center rounded-2xl border border-teal-700 bg-transparent px-4 text-sm font-semibold text-teal-700 transition hover:bg-teal-50"
            (click)="rescheduleAppointment()">Reschedule Appointment</button>

        <button *ngIf="showDeleteButton" type="button"
            class="inline-flex h-11 flex-1 items-center justify-center rounded-2xl border-0 bg-red-700 px-4 text-sm font-semibold text-white transition hover:bg-red-800"
            (click)="deleteAppointment()">Delete</button>
    </div>
</div>

<!-- Previous design retained
<app-page-breadcrumb [pageInfo]="pageInfo" [isModal]="isModal" />
<div class="modal-body  pt-4 mb-4">
    <info-view [formData]="formData" [sourceData]="appointmentData" />
    <div class="text-center mt-3">
        <button class="btn btn-outline-info" (click)="routePatient()">View Patient</button>
        <button class="btn btn-outline-warning" (click)="close()">Close</button>
    </div>
</div>
-->